import { render, staticRenderFns } from "./BaseOptionsMenu.vue?vue&type=template&id=2bae7daf"
import script from "./BaseOptionsMenu.vue?vue&type=script&lang=ts"
export * from "./BaseOptionsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports